<template>
	<div class="chat__contact flex items-center px-2 pt-4 pb-2">
		<div class="contact__avatar mr-1">
			<vs-avatar class="border-2 border-solid border-white" :src="photoURL" size="42px" />
		</div>
		<div class="contact__container w-full flex items-center justify-between overflow-hidden">
			<div class="contact__info flex flex-col truncate w-5/6">
				<h5 class="g-table--title" :class="{'font-semibold': selected}">
					{{ resource.name | capitalize }} {{ resource.lastname | capitalize }}
				</h5>
				<span class="g-table--description truncate">{{ resource.email }}</span>
				<div v-if="componentParent === 'ON_DEMAND'">
					<p>
						<span v-if="!validateNA(availableResourceInfo.distance)">
							<span class="g-label--normal">{{ $t("OnDemand.Distance") }}: </span>
							<span class="g-label--normal text-success"> {{ availableResourceInfo.distance }} km</span>
						</span>
						<span v-if="!validateNA(availableResourceInfo.events)">
							<span class="g-label--normal">{{ $t("RoutesLegends.TotalVisits") }}: </span>
							<span class="g-label--normal text-success"> {{ availableResourceInfo.events }} km</span>
						</span>
					</p>
					<p v-if="!availableResourceInfo.availability_on_demand" class="g-label--normal mt-1">
						{{ $t("OnDemand.DiscardedBy") }}:
					</p>
					<p v-if="!availableResourceInfo.availability_on_demand">
						<span class="text-warning">
							<feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" class="inline-block mr-2" />
						</span>
						<span class="text-sm" :title="information(availableResourceInfo.reason)">
							{{ information(availableResourceInfo.reason) }}
						</span>
					</p>
				</div>
			</div>
			<div
				v-if="componentParent === 'ON_DEMAND'"
				class="chat__contact__meta flex self-start flex-col items-end w-1/6 ml-4"
			>
				<vs-checkbox v-if="availableResourceInfo.availability_on_demand" v-model="selected"></vs-checkbox>
			</div>
			<div v-else class="chat__contact__meta flex self-start flex-col items-end w-1/6 ml-4">
				<vs-checkbox v-if="isActiveChatUser" v-model="selected"></vs-checkbox>
			</div>
		</div>
	</div>
</template>

<script>
import {downloadFileFromFirebase} from "@/helpers/firebaseDB.js";
import firebase from "firebase/app";
import moduleSchedule from "@/store/schedule/moduleSchedule.js";
import moduleResource from "@/store/resource/moduleResource.js";
import Resource from "@/models/Resource.js";

export default {
	props: {
		resource: {type: Object, required: true},
		isActiveChatUser: {type: Boolean, default: true},
		componentParent: {type: String, default: "RESOURCE_CALENDAR"},
		multiple: false,
	},
	data() {
		return {
			database: firebase.database(),
			avatar: "",
			resource_local: JSON.parse(JSON.stringify(this.resource)),
		};
	},
	computed: {
		photoURL() {
			return this.avatar;
		},
		selected: {
			get() {
				return this.resource.selected;
			},
			set(val) {
				if (val) {
					switch (this.componentParent) {
						case "RESOURCE_CALENDAR":
						case "REASSIGN_EVENTS":
							this.$store.commit("moduleResource/SET_SELECTED_RESOURCE", this.resource);
							break;
						case "ON_DEMAND":
							if (this.multiple) {
								this.$store.commit("moduleResource/SET_MULTISELECTED_RESOURCE", this.resource);
							} else {
								this.$store.commit("moduleSchedule/SELECTED_RESOURCE", this.resource);
								this.$store.commit("moduleResource/SET_SELECTED_RESOURCE", this.resource);
							}
							break;
						default:
							break;
					}
				} else {
					switch (this.componentParent) {
						case "RESOURCE_CALENDAR":
						case "REASSIGN_EVENTS":
							const res = new Resource({});
							this.$store.commit("moduleResource/SET_SELECTED_RESOURCE", res);
							break;
						case "ON_DEMAND":
							if (this.multiple) {
								this.$store.commit("moduleResource/SET_MULTISELECTED_RESOURCE", this.resource);
							} else {
								const res = new Resource({});
								this.$store.commit("moduleSchedule/SELECTED_RESOURCE", res);
							}
							break;
						default:
							break;
					}
				}
			},
		},
		availableResources() {
			return this.$store.state.moduleResource.availableResources;
		},
		availableResourcesPayload() {
			return this.$store.state.moduleResource.availableResourcesCurrentPayload;
		},
		availableResourceInfo() {
			const foundResource = this.availableResources.find((r) => r.resource_id === this.resource.id);
			if (foundResource) {
				return foundResource;
			} else {
				return "";
			}
		},
		information() {
			return (reason) => {
				const reasonObj = {
					"not distance": this.$t("OnDemand.NotDistance"),
					"not availability": this.$t("OnDemand.NotAvailability"),
					"not location":
						this.availableResourcesPayload.location === "realtime"
							? this.$t("OnDemand.NotLocation1")
							: this.$t("OnDemand.NotLocation2"),
					"not related zone": this.$t("OnDemand.NotRelatedZone"), // No Relacionado a las zonas donde esta el pv
					"not location zone": this.$t("OnDemand.NotLocation"), // No ubicado en la zona donde esta el pv
					"not events": this.$t("OnDemand.NotLocationZone"),
					"n/a": "",
				};
				return reasonObj[reason] || " ";
			};
		},
		validateNA() {
			return (val) => val === "n/a";
		},
	},
	methods: {
		getResourcePhoto() {
			const url = this.resource.img_url;
			if (!url) {
				return;
			}
			downloadFileFromFirebase(url)
				.then((res) => {
					this.avatar = res;
				})
				.catch((error) => {});
		},
		getSelectedResources() {
			this.$store.dispatch("moduleSchedule/selectedResource", this.resource_local);
		},
	},
	mounted() {
		this.getResourcePhoto();
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}

		if (!moduleSchedule.isRegistered) {
			this.$store.registerModule("moduleSchedule", moduleSchedule);
			moduleSchedule.isRegistered = true;
		}
	},
};
</script>
